module.exports = __webpack_public_path__ + "img/logo-circle.b6945658.svg";